import React from "react";

import { wrap } from "./RydTestbedWrap";
import { NoteRangeType } from "../model/containers";
import NoteRangeSelector from "../components/pickers/NoteRangeSelector";
import { Note } from "../model/core";

export function NoteRangeSelectorTestbed() {
    const [noteRange1, setNoteRange1] = React.useState<NoteRangeType>();
    const [noteRange2, setNoteRange2] = React.useState<NoteRangeType>();

    return wrap(<>
        {/* Add your testbed components here */}
        <h1>NoteRangeSelector Testbed</h1>
        <h2>No effective range</h2>
        <ul>
            <li>Upper note: {noteRange1?.max}/{noteRange1? Note.fromIndex(noteRange1?.max).getName() : '---'}</li>
            <li>Lower note: {noteRange1?.min}/{noteRange1? Note.fromIndex(noteRange1?.min).getName() : '---'}</li>
            <NoteRangeSelector noteRange={noteRange1}
                updateNoteRangeCB={setNoteRange1} />
        </ul>

        <h2>With effective range</h2>

        <ul>
            <li>Upper note: {noteRange2?.max}/{noteRange2? Note.fromIndex(noteRange2?.max).getName() : '---'}</li>
            <li>Lower note: {noteRange2?.min}/{noteRange2? Note.fromIndex(noteRange2?.min).getName() : '---'}</li>
            <NoteRangeSelector noteRange={noteRange2}
                updateNoteRangeCB={setNoteRange2}
                getEffectiveNoteRange={() => { return { min: 48, max: 72 }; }}
            />
        </ul>
    </>);
}